<template>
	<main class="main page-not-found">
		<section class="not-found">
			<div class="not-found__container">
				<div class="not-found__icon" aria-hidden="true">
					<span>404</span>
				</div>

				<h1 class="not-found__title">
					{{ $t('Страница не найдена') }}
				</h1>

				<p class="not-found__meta">
					{{ $t('Проверьте адрес страницы или вернитесь в лавку.') }}
				</p>

				<div class="not-found__actions">
					<button
						type="button"
						class="button bordered not-found__back"
						@click="goBack"
					>
						<span>{{ $t('НАЗАД') }}</span>
					</button>

					<button
						type="button"
						class="button shadowed not-found__store"
						@click="$router.push({ path: '/categories' })"
					>
						<span>{{ $t('В ЛАВКУ') }}</span>
					</button>
				</div>
			</div>
		</section>
	</main>
</template>

<script>
export default {
	name: 'PageNotFound',

	methods: {
		goBack() {
			if (window.history.length > 1) {
				this.$router.back();
				return;
			}

			this.$router.push({
				path: '/categories',
			});
		},
	},
};
</script>

<style scoped lang="scss">
.page-not-found {
	position: relative;
	min-height: 50vh;
	overflow: hidden;
	background: var(--white-woodsmoke);
}

.not-found {
	position: relative;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	padding: 70px 16px 100px;
}

.not-found__container {
	width: 100%;
	max-width: 720px;
	display: flex;
	align-items: center;
	flex-direction: column;
	text-align: center;
}

.not-found__icon {
	position: relative;
	width: 150px;
	height: 95px;
	display: flex;
	align-items: center;
	justify-content: center;

	background: var(--harvest-gold);

	box-shadow: inset 0 -10px 0 rgba(0, 0, 0, 0.24),
		inset -10px 0 0 rgba(0, 0, 0, 0.24),
		inset 0 10px 0 rgba(255, 255, 255, 0.18),
		inset 10px 0 0 rgba(255, 255, 255, 0.18);

	span {
		font-family: var(--font-3);
		font-size: 30px;
		font-weight: 700;
		line-height: 1;
		color: #17110a;
	}
}

.not-found__title {
	margin: 26px 0 0;

	font-family: var(--font-2);
	font-size: 36px;
	font-weight: 700;
	line-height: 120%;

	color: var(--gray-nurse);
}

.not-found__description {
	max-width: 580px;
	margin: 15px 0 0;

	font-family: var(--font-1);
	font-size: 16px;
	font-weight: 400;
	line-height: 130%;

	color: var(--gray-nurse);
}

.not-found__meta {
	max-width: 560px;
	margin: 15px 0 0;

	font-family: var(--font-1);
	font-size: 16px;
	font-weight: 400;
	line-height: 130%;

	color: var(--mantle);
}

.not-found__actions {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 14px;
	margin-top: 36px;
}

.not-found__back,
.not-found__store {
	min-height: 40px;
	justify-content: center;
	margin: 0;
	padding: 12px 23px;

	font-family: var(--font-3);
	font-size: 10px;
	font-weight: 700;
	line-height: 14px;
}

.not-found__back {
	min-width: 122px;
}

.not-found__store {
	min-width: 150px;
}

@media (max-width: 767.98px) {
	.not-found {
		padding: 25px 16px 75px;
	}

	.not-found__icon {
		width: 120px;
		height: 72px;

		span {
			font-size: 24px;
		}
	}

	.not-found__title {
		margin-top: 25px;
		font-size: 27px;
		line-height: 36px;
	}

	.not-found__description,
	.not-found__meta {
		font-size: 14px;
		line-height: 135%;
	}
}

@media (max-width: 480px) {
	.not-found__actions {
		width: 100%;
		flex-direction: column;
	}

	.not-found__back,
	.not-found__store {
		width: 100%;
	}

	.not-found__description,
	.not-found__meta {
		max-width: 320px;
	}
}
</style>
